const initialState = {
    authenticated: false,
    authenticating: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case 'LOG_OUT': {
            return {
                ...state,
                authenticated: false,
                authenticating: false,
            }
        }

        case 'AUTHENTICATE': {
            return {
                ...state,
                authenticated: false,
                authenticating: true,
            }
        }

        case 'AUTHENTICATE_SUCCESS': {
            return {
                ...state,
                authenticated: true,
                authenticating: false,
            }
        }

        case 'AUTHENTICATE_FAILURE': {
            return {
                ...state,
                authenticated: false,
                authenticating: false,
            }
        }

        default:
            return { ...state }
    }
}
